var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "observe-dimensions",
      rawName: "v-observe-dimensions",
      value: _vm.dimensions,
      expression: "dimensions"
    }],
    staticClass: "verticalStepList"
  }, [_c('div', [_c('div', {
    style: {
      height: "".concat(_vm.paddingHeight, "px")
    },
    attrs: {
      "id": "topPadding"
    }
  }), _c('div', {
    attrs: {
      "id": "verticalSteps"
    }
  }, _vm._l(_vm.stepList, function (step, stepIndex) {
    return _c('CenterScreenObserver', {
      key: step.key || stepIndex,
      attrs: {
        "verticalOnly": ""
      },
      nativeOn: {
        "click": function click($event) {
          return _vm.scrollToStep($event);
        }
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function fn(_ref) {
          var isCenterScreen = _ref.isCenterScreen;
          return [_c('div', {
            key: step.key || stepIndex,
            ref: "steps",
            refInFor: true,
            staticClass: "verticalStep",
            class: {
              isCenterScreen: isCenterScreen
            }
          }, [_vm._t("default", null, null, {
            step: step,
            stepIndex: stepIndex,
            isCenterScreen: isCenterScreen
          })], 2)];
        }
      }], null, true)
    });
  }), 1), _c('div', {
    style: {
      height: "".concat(_vm.paddingHeight, "px")
    }
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }